module.exports = __webpack_public_path__ + "static/media/Mahogny_SUPER.0fac0934.mp4";